/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 2
 * API documentations version 2.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIErrorV2 } from '../model';
// @ts-ignore
import { CreateIndividualDOPRequest } from '../model';
// @ts-ignore
import { CreateIndividualMbBankRequest } from '../model';
// @ts-ignore
import { CreateIndividualMbBankResponse } from '../model';
// @ts-ignore
import { CreateOrganizationEntity200Response } from '../model';
// @ts-ignore
import { CreatedDOPIndividual } from '../model';
// @ts-ignore
import { OrganizationDto } from '../model';
// @ts-ignore
import { Phone } from '../model';
/**
 * OnboardingApi - axios parameter creator
 * @export
 */
export const OnboardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This creates a new individual entity for DOP flow. This new entity has verified phone number. 
         * @summary Creates Individual Entity
         * @param {CreateIndividualDOPRequest} createIndividualDOPRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualEntityForDop: async (createIndividualDOPRequest: CreateIndividualDOPRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIndividualDOPRequest' is not null or undefined
            assertParamExists('createIndividualEntityForDop', 'createIndividualDOPRequest', createIndividualDOPRequest)
            const localVarPath = `/v2/public/onboarding/dop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = createIndividualDOPRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This creates a new individual entity for MBBank. 
         * @summary Creates Individual Entity from MBBank
         * @param {CreateIndividualMbBankRequest} createIndividualMbBankRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualEntityMbBank: async (createIndividualMbBankRequest: CreateIndividualMbBankRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIndividualMbBankRequest' is not null or undefined
            assertParamExists('createIndividualEntityMbBank', 'createIndividualMbBankRequest', createIndividualMbBankRequest)
            const localVarPath = `/v2/public/onboarding/mbbank`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = createIndividualMbBankRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation creates a pending organization entity in Credify network. This request needs to be reviewed by admin. 
         * @summary Creates Organization Entity
         * @param {OrganizationDto} organizationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationEntity: async (organizationDto: OrganizationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationDto' is not null or undefined
            assertParamExists('createOrganizationEntity', 'organizationDto', organizationDto)
            const localVarPath = `/v2/public/onboarding/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = organizationDto

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This sends a 6-digit code for phone number verification 
         * @summary Sends OTP via SMS
         * @param {Phone} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtpSms: async (phone: Phone, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('sendOtpSms', 'phone', phone)
            const localVarPath = `/v2/public/onboarding/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = phone

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingApi - functional programming interface
 * @export
 */
export const OnboardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingApiAxiosParamCreator(configuration)
    return {
        /**
         * This creates a new individual entity for DOP flow. This new entity has verified phone number. 
         * @summary Creates Individual Entity
         * @param {CreateIndividualDOPRequest} createIndividualDOPRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIndividualEntityForDop(createIndividualDOPRequest: CreateIndividualDOPRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedDOPIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIndividualEntityForDop(createIndividualDOPRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This creates a new individual entity for MBBank. 
         * @summary Creates Individual Entity from MBBank
         * @param {CreateIndividualMbBankRequest} createIndividualMbBankRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIndividualEntityMbBank(createIndividualMbBankRequest: CreateIndividualMbBankRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateIndividualMbBankResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIndividualEntityMbBank(createIndividualMbBankRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation creates a pending organization entity in Credify network. This request needs to be reviewed by admin. 
         * @summary Creates Organization Entity
         * @param {OrganizationDto} organizationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationEntity(organizationDto: OrganizationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrganizationEntity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationEntity(organizationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This sends a 6-digit code for phone number verification 
         * @summary Sends OTP via SMS
         * @param {Phone} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOtpSms(phone: Phone, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOtpSms(phone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OnboardingApi - factory interface
 * @export
 */
export const OnboardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingApiFp(configuration)
    return {
        /**
         * This creates a new individual entity for DOP flow. This new entity has verified phone number. 
         * @summary Creates Individual Entity
         * @param {CreateIndividualDOPRequest} createIndividualDOPRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualEntityForDop(createIndividualDOPRequest: CreateIndividualDOPRequest, options?: any): AxiosPromise<CreatedDOPIndividual> {
            return localVarFp.createIndividualEntityForDop(createIndividualDOPRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This creates a new individual entity for MBBank. 
         * @summary Creates Individual Entity from MBBank
         * @param {CreateIndividualMbBankRequest} createIndividualMbBankRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualEntityMbBank(createIndividualMbBankRequest: CreateIndividualMbBankRequest, options?: any): AxiosPromise<CreateIndividualMbBankResponse> {
            return localVarFp.createIndividualEntityMbBank(createIndividualMbBankRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation creates a pending organization entity in Credify network. This request needs to be reviewed by admin. 
         * @summary Creates Organization Entity
         * @param {OrganizationDto} organizationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationEntity(organizationDto: OrganizationDto, options?: any): AxiosPromise<CreateOrganizationEntity200Response> {
            return localVarFp.createOrganizationEntity(organizationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This sends a 6-digit code for phone number verification 
         * @summary Sends OTP via SMS
         * @param {Phone} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtpSms(phone: Phone, options?: any): AxiosPromise<void> {
            return localVarFp.sendOtpSms(phone, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnboardingApi - interface
 * @export
 * @interface OnboardingApi
 */
export interface OnboardingApiInterface {
    /**
     * This creates a new individual entity for DOP flow. This new entity has verified phone number. 
     * @summary Creates Individual Entity
     * @param {CreateIndividualDOPRequest} createIndividualDOPRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    createIndividualEntityForDop(createIndividualDOPRequest: CreateIndividualDOPRequest, options?: AxiosRequestConfig): AxiosPromise<CreatedDOPIndividual>;

    /**
     * This creates a new individual entity for MBBank. 
     * @summary Creates Individual Entity from MBBank
     * @param {CreateIndividualMbBankRequest} createIndividualMbBankRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    createIndividualEntityMbBank(createIndividualMbBankRequest: CreateIndividualMbBankRequest, options?: AxiosRequestConfig): AxiosPromise<CreateIndividualMbBankResponse>;

    /**
     * This operation creates a pending organization entity in Credify network. This request needs to be reviewed by admin. 
     * @summary Creates Organization Entity
     * @param {OrganizationDto} organizationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    createOrganizationEntity(organizationDto: OrganizationDto, options?: AxiosRequestConfig): AxiosPromise<CreateOrganizationEntity200Response>;

    /**
     * This sends a 6-digit code for phone number verification 
     * @summary Sends OTP via SMS
     * @param {Phone} phone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    sendOtpSms(phone: Phone, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * OnboardingApi - object-oriented interface
 * @export
 * @class OnboardingApi
 * @extends {BaseAPI}
 */
export class OnboardingApi extends BaseAPI implements OnboardingApiInterface {
    /**
     * This creates a new individual entity for DOP flow. This new entity has verified phone number. 
     * @summary Creates Individual Entity
     * @param {CreateIndividualDOPRequest} createIndividualDOPRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public createIndividualEntityForDop(createIndividualDOPRequest: CreateIndividualDOPRequest, options?: AxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).createIndividualEntityForDop(createIndividualDOPRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This creates a new individual entity for MBBank. 
     * @summary Creates Individual Entity from MBBank
     * @param {CreateIndividualMbBankRequest} createIndividualMbBankRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public createIndividualEntityMbBank(createIndividualMbBankRequest: CreateIndividualMbBankRequest, options?: AxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).createIndividualEntityMbBank(createIndividualMbBankRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation creates a pending organization entity in Credify network. This request needs to be reviewed by admin. 
     * @summary Creates Organization Entity
     * @param {OrganizationDto} organizationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public createOrganizationEntity(organizationDto: OrganizationDto, options?: AxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).createOrganizationEntity(organizationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This sends a 6-digit code for phone number verification 
     * @summary Sends OTP via SMS
     * @param {Phone} phone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public sendOtpSms(phone: Phone, options?: AxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).sendOtpSms(phone, options).then((request) => request(this.axios, this.basePath));
    }
}
